import { Component } from "react";
import { Box, Heading, Text, Center } from "@chakra-ui/react";
import { AppContext } from "global";

class ErrorShell extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError || this.context.processingError) {
      console.error(this.state.error ?? this.context.processingError);
      return (
        <Box maxW={{ xl: "1200px" }}>
          <Heading size="md">Oops, Mock Shop has crashed!</Heading>
          <Center mt="1em">
            <Text>
              You should probably report this in the Prospective Vendor group on
              Facebook and/or email us with your inventory sheet @
              pnpfair@gmail.com
            </Text>
          </Center>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorShell;
